import { useAuth } from '@/lib/auth';
import { ReactComponent as Logo } from '@/assets/img/logo-v2.svg';
import { ReactComponent as PasswordShowIcon } from '@/assets/img/v2/password-show-icon.svg';
import { ReactComponent as PasswordHideIcon } from '@/assets/img/v2/password-hide-icon.svg';

import { ChangeEvent, useEffect, useState } from 'react';
import { showNotification } from '@/utils/notificationUtils';
import Utils from '@/utils/util';
import './ConsumerLogin.scss';
import PhoneInput from 'react-phone-input-2';
import { Loader } from '@/components/Loader/Loader';
import { useTranslation } from 'react-i18next';
type SignupFormProps = {
  onBack: (page: 'serviceSelection') => void;
  onNext: (page: 'forgot-password' | 'sign-up' | 'email-verification' | 'login') => void;
};
type UserData = {
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
};
export const ConsumerSignUp = ({ onBack, onNext }: SignupFormProps) => {
  const { register } = useAuth();
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [userData, setUserData] = useState<UserData>({
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
  });


  useEffect(() => {
    Utils.scrollToTop();
  }, [])
  
  const handleFormChange = (formFieldName: string, value: string) => {
    userData[formFieldName as keyof typeof userData] = value;
    setUserData({ ...userData });
  };

  const validate = () => {
    const { email, password, confirmPassword, phone } = userData;
    if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      showNotification({
        type: 'info',
        title: t('Please enter valid email'),
      });
      return false;
    } else if (!password) {
      showNotification({
        type: 'info',
        title: t('Please enter password'),
      });
      return false;
    } else if (!confirmPassword || password != confirmPassword) {
      showNotification({
        type: 'info',
        title: t('Password not matched'),
      });
      return false;
    } else if (!phone || phone.trim().length < 1) {
      showNotification({
        type: 'info',
        title: t('Please enter valid phone number'),
      });
      return false;
    }
    return true;
  };
  const onRegister = async () => {
    const { email, password, confirmPassword, phone } = userData;
    if (validate()) {
      //setIsLoading(true);
      await register({
        email: email.toLowerCase(),
        password,
        confirmPassword,
        phone, 
      });
      setIsLoading(false);
      localStorage.setItem('UsersEmail', email.toLowerCase());
      onNext('email-verification');
    }
  };

  return (
    <section className="consumer-login">
      <div className="registration-container">
        <div className="logo-section">
          <Logo />
          <p className="petsked-desc">{t('Get started, create a new account')}</p>
        </div>
        <div className="petsked-form">
          <input
            id="email"
            type="email"
            value={userData.email}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleFormChange('email', e.target.value)
            }
            placeholder={t("Enter your email")}
          />
          <PhoneInput
            country={'us'}
            value={userData.phone}
            onChange={(data: any) => handleFormChange('phone', data)}
            countryCodeEditable={false}
          />
          <span className="form-field-wrapper">
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              value={userData.password}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleFormChange('password', e.target.value)
              }
              placeholder={t("Password")}
            />
            {showPassword ? (
              <PasswordHideIcon onClick={() => setShowPassword(!showPassword)} />
            ) : (
              <PasswordShowIcon onClick={() => setShowPassword(!showPassword)} />
            )}
          </span>
          <span className="form-field-wrapper">
            <input
              id="password"
              type={showConfirmPassword ? 'text' : 'password'}
              value={userData.confirmPassword}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleFormChange('confirmPassword', e.target.value)
              }
              placeholder={t("Confirm Password")}
            />
            {showConfirmPassword ? (
              <PasswordHideIcon onClick={() => setShowConfirmPassword(!showConfirmPassword)} />
            ) : (
              <PasswordShowIcon onClick={() => setShowConfirmPassword(!showConfirmPassword)} />
            )}
          </span>
          <div className="action">
            <button
              className="petsked-button button-dark"
              onClick={onRegister}
              disabled={isLoading}
            >
              {isLoading ? <Loader text='Signing up...' /> : <span>{t('Sign Up')}</span>}
            </button>
            <p className="terms">
              {t('By continuing, you agree to our')} <b>{t('Terms')}</b> {t('and')} <b>{t('Privacy Policy')}</b>, {t('and to receive emails and updates.')}
            </p>
            <p className="sign-up-link signup">
              {t('Have an account?')} <a onClick={() => onNext('login')}>{t('Sign In Now')}</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
